import { Container } from "./styles";
import emailIcon from "../../assets/email-icon.svg";
import phoneIcon from "../../assets/phone-icon.svg"
import { Form } from "../Form/Form";
import { useLanguage } from "../../i18n/LanguageContext";


export function Contact() {
  const { t } = useLanguage();

  return (
    <Container id="contact">
      <header>
        <h2>{t.contact.heading}</h2>
        <p>{t.contact.intro}</p>
      </header>
      <div className="contacts">
        <div>
          <img src={emailIcon} alt={t.contact.emailAlt} />
          <a href="mailto:dario.humerez.dev@gmail.com">dario.humerez.dev@gmail.com</a>
        </div>
        <div>
          <img src={phoneIcon} alt={t.contact.phoneAlt} />
          <a href="tel:+59178872560">(+591) 78872560</a>
        </div>
      </div>
      <Form></Form>
    </Container>
  )
}